export const getRateKey = (podcast: string, episode: string, profile?: string) =>
  `poscast=${podcast}&episode=${episode}&profile=${profile || 0}`
